import React from 'react';
import styled from 'styled-components';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';

const TshLogo = styled.img`
  position: absolute;
  left: calc(50% - 55.5px);
  top: calc(50% - 45px);
  z-index: 2;
  pointer-events: none;
`;

const TshBackdrop = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(60, 60, 60, 0.5);
  opacity: 0.2;
  border-radius: 8px 0px 0px 8px;
  z-index: 1;
  pointer-events: none;
`;

/** Top-Secret-Hotels overlay shown on top of the gallery image */
const TopSecretHotelsGalleryOverlay = () => {
  const { localization } = usePageWrapperData();
  return (
    <>
      <TshLogo
        src={`${localization.imageBasePath}icons/top_secret_hotel.svg`}
        alt="top secret hotel"
        width={111}
        height={90}
      />
      <TshBackdrop />
    </>
  );
};

export default TopSecretHotelsGalleryOverlay;
